<div class="p-3 home-innov-page">
  <div class="col-12">

    <div class="d-flex justify-content-end align-items-center mb-3">
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="toggleCustomizeMode()"
        title="Personnaliser le dashboard"
      >
        <fa-icon [icon]="customizeMode ? 'times' : 'sliders'"></fa-icon>
      </button>
    </div>

    <div class="dashboard-layout" [class.customize-open]="customizeMode">

      <div class="dashboard-main">
        <div
          class="dashboard-grid"
          cdkDropList
          [cdkDropListData]="visibleWidgets"
          cdkDropListOrientation="mixed"
          [cdkDropListDisabled]="!customizeMode"
          (cdkDropListDropped)="drop($event)"
        >
          @for (widget of visibleWidgets; track trackByWidget($index, widget)) {
            <div
              class="dashboard-grid-item"
              cdkDrag
              [cdkDragDisabled]="!customizeMode"
              [style.grid-column]="getWidgetGridColumn(widget)"
              [style.grid-row]="getWidgetGridRow(widget)"
            >
              <div class="dashboard-widget-wrapper position-relative h-100">
                @if (customizeMode) {
                  <div class="drag-handle" cdkDragHandle>
                    <fa-icon icon="grip-vertical"></fa-icon>
                  </div>
                }

                @switch (widget.id) {

                  <!-- Opérateurs -->
                  @case ('operateurs') {
                    <div class="cards border-radius text-center h-100">
                      <div class="row">
                        <div class="col-lg-6 text-start">
                          <div class="border-radius pt-4 text-center">
                            <fa-icon icon="users" class="users-icon"></fa-icon><br />
                            <strong class="dashboard-big-number">{{ nbOperateurs }}</strong>
                            <h5 class="dashboard-operator-title">Opérateur(s)</h5>
                          </div>

                          <div class="text-center pt-4">
                            <button (click)="searchUser()" type="button" class="btn btn-primary">
                              <fa-icon icon="search"></fa-icon>
                              <span class="ps-2">Rechercher un opérateur</span>
                            </button>
                          </div>
                        </div>

                        <div class="col-lg-6 text-center pt-2">
                          <div class="dashboard-chart" echarts [options]="chartHabilitation"></div>
                          <strong class="d-block">Habilitations</strong>
                        </div>
                      </div>
                    </div>
                  }

                  <!-- Commissions -->
                  @case ('commissions') {
                    <div class="cards border-radius p-2 h-100">
                      <div class="d-flex align-items-center">
                        <fa-icon icon="calendar-alt" class="p-2 dashboard-icon"></fa-icon>
                        <strong>Commissions</strong>
                      </div>
                      @for (groupCommission of groupCommissions; track trackByGroupCommission($index, groupCommission)) {
                        <div>
                          <div class="w-auto border-bottom">{{ groupCommission.key }}</div>
                          @for (item of groupCommission.items; track trackByCommission($index, item)) {
                            <div>
                              <div class="pointer" (click)="goToCommission(item)" (keydown.enter)="goToCommission(item)">
                                <span class="badge rounded-pill badge-light-orange">{{ item.debut | date:'HH:mm' }}</span>
                                {{ item.numero }} - {{ item.nbEchantillons }} échantillons - Jurés {{ item.nbJuresPresents }}/{{ item.nbJuresTotal }}
                              </div>
                            </div>
                          }
                          <br />
                        </div>
                      }
                      @if (groupCommissions.length === 0) {
                        <span class="pl-4">
                          Aucune commission programmée.
                        </span>
                      }
                    </div>
                  }

                  <!-- Télédeclarations -->
                  @case ('teledeclarations') {
                    <div class="cards border-radius p-2 pb-4 text-center h-100">
                      <fa-icon icon="file-contract" class="mt-2 p-2 dashboard-icon"></fa-icon>
                      <strong>Télédéclarations</strong>
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="border-radius p-2 pointer" (click)="goToSuivi()">
                            <div class="badge-light badge-light-red">
                              {{ nbDeclarationsNonLues }}
                            </div>
                            <p><small style="display:block;">nouvelle(s)</small></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  <!-- Contrôles -->
                  @case ('controles') {
                    <div class="cards border-radius p-2 pb-2 text-center h-100">
                      <fa-icon icon="clipboard-check" class="mt-2 p-2 dashboard-icon"></fa-icon>
                      <strong>Contrôles</strong>
                      <div class="row">
                        <div class="col-lg-3 col-md-6 col-12">
                          <div class="border-radius p-2">
                            <div class="badge-light badge-light-vert">
                              {{ nbControlesPrevus }}
                            </div>
                            <p><small style="display:block;">contrôle(s)<br /> programmé(s)</small></p>
                          </div>
                        </div>

                        <div class="col-lg-3 col-md-6 col-12">
                          <div class="border-radius p-2">
                            <div class="badge-light badge-light-blue">
                              {{ nbEchantillons?.[1] ?? 0 }}
                            </div>
                            <p><small style="display:block;">échantillon(s) <br />à prélever</small></p>
                          </div>
                        </div>

                        <div class="col-lg-3 col-md-6 col-12">
                          <div class="border-radius p-2">
                            <div class="badge-light badge-light-orange">
                              {{ nbEchantillons?.[0] ?? 0 }}
                            </div>
                            <p><small style="display:block;">échantillon(s) <br />prélevé(s)</small></p>
                          </div>
                        </div>

                        <div class="col-lg-3 col-md-6 col-12">
                          <div class="border-radius p-2">
                            <div class="badge-light badge-light-red">
                              {{ nbManquement }}
                            </div>
                            <p><small style="display:block;">manquement(s)<br /> à échéance</small></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  <!-- Historique -->
                  @case ('historique') {
                    <div class="cards border-radius p-2 h-100 overflow-y-auto">
                      <div class="d-flex align-items-center">
                        <fa-icon icon="history" class="p-2 dashboard-icon"></fa-icon>
                        <strong>Historique des modifications majeures</strong>
                      </div>
                      @for (modification of modifications; track $index) {
                        <div>
                          <div class="w-auto border-bottom">
                            <strong>{{ modification.dateModification | date:'dd/MM/yyyy' }}</strong>
                            <span>-</span>
                            <span>{{ modification.newRow.raisonSociale }}</span>
                            @if (hasOrganisme(modification.idOrganisme)) {
                              <span>
                                ({{ getOrganisme(modification.idOrganisme) }})
                              </span>
                            }
                          </div>
                          <br />
                        </div>
                      }
                      @if (modifications.length === 0) {
                        <span class="pl-4">
                          Aucune modification majeure réalisée.
                        </span>
                      }
                      <div class="text-right pointer">
                        <a (click)="goToDetail()" class="cursor-pointer">
                          <strong>Détails</strong>
                          <fa-icon icon="chevron-right" class="right"></fa-icon>
                        </a>
                      </div>
                    </div>
                  }

                  <!-- Dépot DR -->
                  @case ('depot-dr') {
                    <div class="cards border-radius p-2 pb-4 text-center h-100">
                      <fa-icon icon="download" class="mt-2 p-2 dashboard-icon"></fa-icon>
                      <strong>Dépôt de DR</strong>
                      <div class="row">
                        <div class="col-lg-6 col-12">
                          <div class="border-radius p-2">
                            <div class="badge-light badge-light-vert pointer" (click)="gotToDrDrevSaisiesToDr(TypeDr.TOUTES)" (keydown.enter)="gotToDrDrevSaisiesToDr(TypeDr.TOUTES)">
                              {{ totalDR }}
                            </div>
                            <p><small style="display:block;">DR au total</small></p>
                          </div>
                        </div>
                        <div class="col-lg-6 col-12">
                          <div class="border-radius p-2">
                            <div class="badge-light badge-light-blue pointer" (click)="gotToDrDrevSaisiesToDr(TypeDr.MODIFIEE)" (keydown.enter)="gotToDrDrevSaisiesToDr(TypeDr.MODIFIEE)">
                              {{ nbDrUpdate }}
                            </div>
                            <p><small style="display:block;">DR modifiée(s)</small></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  <!-- DREV -->
                  @case ('drev-aoc') {
                    <div class="cards border-radius p-2 pb-2 text-center h-100">
                      <fa-icon icon="chart-line" class="mt-2 p-2 dashboard-icon"></fa-icon>
                      <strong>DREV AOC</strong>
                      <div class="row">
                        <div class="col-lg-4 col-md-6 col-12">
                          <div class="border-radius p-2">
                            <div class="badge-light badge-light-vert pointer" (click)="gotToDrDrevSaisiesToDrev(TypeDr.TOUTES)" (keydown.enter)="gotToDrDrevSaisiesToDrev(TypeDr.TOUTES)">
                              {{ nbDrevSaisie }}
                            </div>
                            <p><small style="display:block;">DREV saisie(s)</small></p>
                          </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-12">
                          <div class="border-radius p-2">
                            <div class="badge-light badge-light-blue pointer" (click)="goToManquantes()" (keydown.enter)="goToManquantes()">
                              {{ nbDrevManquantes }}
                            </div>
                            <p><small style="display:block;">vinificateur(s)<br />sans DREV</small></p>
                          </div>
                        </div>

                        <div class="col-lg-4 col-md-12 col-12">
                          <div class="border-radius p-2">
                            <div class="badge-light badge-light-orange pointer" (click)="goToDrevSynthese()" (keydown.enter)="goToDrevSynthese()">
                              <fa-icon icon="table" style="font-size:20px"></fa-icon>
                            </div>
                            <p><small style="display:block;">Synthèse</small></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                }
              </div>
            </div>
          }
        </div>
      </div>

      @if (customizeMode) {
        <aside class="dashboard-sidebar">
          <div class="cards border-radius p-3 dashboard-customize-card">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <strong>Personnalisation</strong>

              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="resetDashboard()">
                <fa-icon icon="undo"></fa-icon>
                <span class="ps-2">Réinitialiser</span>
              </button>
            </div>

            <p class="text-muted mb-3">
              Vous pouvez afficher/masquer les widgets, modifier leur taille, leur hauteur et les déplacer.
            </p>

            <div class="dashboard-customize-body">
              @for (widget of allWidgets; track trackByWidget($index, widget)) {
                <div>
                  <div class="dashboard-config-row">
                    <div class="form-check dashboard-config-main">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [id]="'widget-' + widget.id"
                        [checked]="widget.visible"
                        (change)="toggleWidget(widget.id)"
                      />
                      <label class="form-check-label" [for]="'widget-' + widget.id">
                        {{ widget.title }}
                      </label>
                    </div>

                    <div class="dashboard-config-actions">
                      <div class="dashboard-size-select">
                        <label class="form-label mb-1">Largeur</label>
                        <select
                          class="form-select form-select-sm"
                          [(ngModel)]="widget.size"
                          [disabled]="!widget.visible"
                          (ngModelChange)="changeWidgetSize(widget.id, $event)"
                        >
                          @for (size of widgetSizes; track size.value) {
                            <option [ngValue]="size.value">
                              {{ size.label }}
                            </option>
                          }
                        </select>
                      </div>

                      <div class="dashboard-size-select">
                        <label class="form-label mb-1">Hauteur</label>
                        <select
                          class="form-select form-select-sm"
                          [(ngModel)]="widget.height"
                          [disabled]="!widget.visible"
                          (ngModelChange)="changeWidgetHeight(widget.id, $event)"
                        >
                          @for (height of widgetHeights; track height.value) {
                            <option [ngValue]="height.value">
                              {{ height.label }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </aside>
      }

    </div>
  </div>
</div>
